import { getCache } from './cache'
export const checkPermissions = (name) => {
    const permissionsJsonStr = getCache('role_perm')
    if (permissionsJsonStr) {
        const permissions = JSON.parse(permissionsJsonStr)
        console.log(permissions)
        return permissions[name]
    }
    return false
}


// WEBPACK FOOTER //
// ./src/utils/permissions.js